/* Extenal */
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

function FocusableDiv({
  className, onMouseEnter, onMouseLeave, children,
}) {
  return (
    <div className={className} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {children}
    </div>
  );
}

FocusableDiv.propTypes = {
  className: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node.isRequired,
};

FocusableDiv.defaultProps = {
  className: '',
  onMouseEnter: undefined,
  onMouseLeave: undefined,
};

export default withFocusable()(FocusableDiv);
